<template>
  <div class="kt-grid kt-grid--ver kt-grid--root kt-page">
    <div class="kt-grid kt-grid--hor kt-grid--root  kt-login kt-login--v6"
         :class="`kt-login--${type}`">

      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">

        <div class="kt-grid__item  kt-grid__item--order-tablet-and-mobile-2  kt-grid kt-grid--hor kt-login__aside">
          <div class="kt-login__wrapper">
            <div class="kt-login__container">
              <div class="kt-login__body fadeInDown animated">
                <slot name="logo" />

                <slot name="signin" />

                <slot name="signup" />

                <slot name="passwordRecovery" />

                <slot name="passwordReset" />
              </div>
            </div>
          </div>
          <div class="kt-login__account">
            <div class="powered-by-text">Powered by<br><img src="/img/logo-itp.png" width="80"></div>
            All rights reserved: ©Global Encounters™ 1999-{{ year }}
          </div>
        </div>

        <slot name="content" />

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageWrapper',
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    year () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.kt-login__account {
  display: flex;
  align-content: flex-end;
  justify-content: center;
  align-items: flex-end;
}
.powered-by-text {
  font-size: 1rem;
  font-weight: 600;
  margin-right: 10px;
}
</style>
